import UserService from '@/bundles/Users/services/UserService';
import { http } from '@/bundles/Http/factory/HttpFactory';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';

function userServiceFactory() {
  return new UserService(http, new ErrorMapper());
}

export const userService = userServiceFactory();
